import React, { createContext, useContext, useState, useEffect } from 'react';
import { crmAPI } from '../services/api';

const CRMAuthContext = createContext(null);

export const CRMAuthProvider = ({ children }) => {
  const [crmUser, setCrmUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('crm_token');
    if (token) {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        if (payload.exp * 1000 > Date.now()) {
          setCrmUser({ id: payload.crmUserId, role: payload.role, name: payload.name });
        } else {
          localStorage.removeItem('crm_token');
        }
      } catch {
        localStorage.removeItem('crm_token');
      }
    }
    setLoading(false);
  }, []);

  const crmLogin = async (username, password) => {
    const res = await crmAPI.login({ username, password });
    localStorage.setItem('crm_token', res.data.token);
    setCrmUser(res.data.user);
    return res.data.user;
  };

  const crmLogout = () => {
    localStorage.removeItem('crm_token');
    setCrmUser(null);
    window.location.href = '/crm';
  };

  return (
    <CRMAuthContext.Provider value={{ crmUser, loading, crmLogin, crmLogout }}>
      {children}
    </CRMAuthContext.Provider>
  );
};

export const useCRMAuth = () => useContext(CRMAuthContext);
